import { Group } from '@mantine/core';
import { inkBase, inkLighter } from '../../../../styles/design-tokens';
import { Text } from '../../../../ui-library/typography/typography';
import { ReactNode } from 'react';

type Props = {
  label: string;
  value?: ReactNode | string | number | null;
};

export const SideSectionInfoItem = ({ label, value }: Props) => {
  const isValueComponent = typeof value === 'object';

  return (
    <Group key={label} justify="space-between">
      <Text size="tiny" color={inkLighter} style={{ maxWidth: '50%', wordBreak: 'break-word' }}>
        {label}
      </Text>
      <Text size="tiny" color={inkBase} style={{ maxWidth: '50%', wordBreak: 'break-word', textAlign: 'right' }}>
        {isValueComponent ? (
          value
        ) : (
          <Text size="tiny" color={inkBase}>
            {value}
          </Text>
        )}
      </Text>
    </Group>
  );
};
